<template>
  <div>
    <h3>Step Images</h3>
    <!-- New Answer -->
    <v-row>
      <v-col cols="5">
        <v-text-field v-model="newStepImage" label="Image"></v-text-field>
      </v-col>
      <v-col cols="1">
        <v-btn class="primary-btn" @click="add">Add</v-btn>
      </v-col>
    </v-row>

    <!-- Existing Validations -->
    <v-row v-for="(item, index) in stepImages" :key="'step-image-'+index">
      <v-col cols="5">
        <span>{{ item }}</span>
      </v-col>
      <v-col cols="1">
        <v-btn icon @click="remove(index)"><v-icon>mdi-close</v-icon></v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      stepImages: this.value,
      newStepImage: null,
    }
  },
  watch: {
    value: {
      handler(newValue) {
        this.stepImages = newValue;
      },
      deep: true
    },
    stepImages: {
      handler(newValue) {
        this.$emit('input', newValue);
      },
      deep: true
    }
  },
  methods: {
    add() {
      this.stepImages.push(this.newStepImage);
      this.newStepImage = null;
    },
    remove(index) {
      this.stepImages.splice(index, 1);
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/theme.scss";
.primary-btn {
  color: white;
  background-color: $ausloans-blue !important;
}
</style>